// extracted by mini-css-extract-plugin
export default {"title":"styles_title__uAj2e","summary-value":"styles_summary-value__kZfw1"};